import * as types from './action-types'

export const fetchBankHolidayRegions = countryCode => ({
  type: types.BANK_HOLIDAY_REGIONS_FETCH_BEGIN,
  payload: { countryCode },
})
